import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

import "./Header.css";
import global from "../../config";
import Logo from "../../assets/images/logo-horiz.png";
import User from "../../assets/images/user.png";
import { Link } from "react-router-dom";
export default function Header(props) {
  const navigate = useNavigate();

  const [toggleUserBlock, setToggleUser] = useState(false);
  const [totalShows, setTotalShows] = useState(
    localStorage.getItem("totalShows")
  );
  const [totalCreators, setTotalCreators] = useState(
    localStorage.getItem("totalCreators")
  );
  const [completeVideos, setCompleteVideos] = useState(
    localStorage.getItem("completeVideos")
  );
  const [incompleteVideos, setIncompleteVideos] = useState(
    localStorage.getItem("incompleteVideos")
  );

  const toggleUser = () => {
    setToggleUser(!toggleUserBlock);
  };

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const navigateToShows = (e) => {
    navigate("/admin/shows");
  };

  const navigateToCreator = (e) => {
    navigate("/admin/creators");
  };

  const navigateToAssetsComplete = (e) => {
    navigate("/admin/assets/complete");
  };

  const navigateToAssetsInComplete = (e) => {
    navigate("/admin/assets/in-complete");
  };

  const navigateToIngest = (e) => {
    navigate("/admin/ingest/view");
  };

  async function getMenuCount() {
    const idToken = localStorage.getItem("idToken");
    const payload = { operation: "countRecords" };
    if (idToken) {
      const response = await axios.post(global.apiURL + "/shows", payload, {
        headers: { Authorization: "Bearer " + idToken },
      });
      if (response.data) {
        setTotalShows(response.data.totalShows);
        setTotalCreators(response.data.totalCreators);
        setCompleteVideos(response.data.completeVideos);
        setIncompleteVideos(response.data.incompleteVideos);

        localStorage.setItem("totalShows", response.data.totalShows);
        localStorage.setItem("totalCreators", response.data.totalCreators);
        localStorage.setItem("completeVideos", response.data.completeVideos);
        localStorage.setItem("incompleteVideos", response.data.incompleteVideos);
      }
    }
  }

  useEffect(() => {
    getMenuCount();
  }, []);

  return (
    <header>
      <div className="container-header">
        <div className="header-column">
          <div className="dashboard-header-logo">
            <img src={Logo} alt="CMS Video" />
          </div>

          <div className="dashboard-nav">
            <ul>
              <li onClick={navigateToCreator}>
                <Link to="" title="">
                  <span>Creators ({totalCreators})</span>
                </Link>
              </li>
              <li onClick={navigateToShows}>
                <Link to="" title="">
                  <span>Shows ({totalShows})</span>
                </Link>
              </li>

              <li>
                <Link to="" title="">
                  <span>Assets</span>
                </Link>
                <ul>
                  <li onClick={navigateToAssetsComplete}>
                    <Link to="" title="">
                      <span>Complete ({completeVideos})</span>
                    </Link>
                  </li>
                  <li onClick={navigateToAssetsInComplete}>
                    <Link to="" title="">
                      <span>Incomplete ({incompleteVideos})</span>
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="" title="">
                  <span>Ingested</span>
                </Link>
                <ul>
                  <li onClick={navigateToIngest}>
                    <Link to="" title="">
                      <span>To Correct</span>
                    </Link>
                  </li>
                </ul>
              </li>

              <li onClick={logout}>
                <Link to="" title="">
                  <span>Logout</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}
